@if (!erreurRecuperation()) {
  <div>
    <app-data-table
      [data]="tabEquipments()"
      [columns]="tableColumns"
      [clickable]="true"
      (selectionLigne)="ouvrirModale($event)"
    />
    <div class="footer">
      <app-button
        variant="primary"
        [label]="'GLOBAL.AJOUTER' | translate"
        [addIconLeft]="true"
        (clicked)="ouvrirModaleAjout()"
      >
        <i slot="icon-left" class="fas fa-plus"></i>
      </app-button>
      @if (utilService.currentSite()?.siteId == 189) {
        <button [disabled]="isSync()" class="btn btn-success" (click)="syncEquipments()"><i class="fas fa-sync" style="padding-right: 5px;"></i>{{'Sync'}}</button>
      }
    </div>
  </div>
}
@if (erreurRecuperation()) {
  <div class="custom-alert custom-alert-sm">
    {{'GLOBAL.ERREUR_RECUP_DONNEES' | translate }}
  </div>
}
